import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const BranchIcon = React.memo(function BranchIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="4.5" cy="12.5" r="2" stroke={color} />
      <circle cx="10.5" cy="5.5" r="2" stroke={color} />
      <circle cx="4.5" cy="2.5" r="2" stroke={color} />
      <line x1="4.5" y1="4" x2="4.5" y2="11" stroke={color} />
      <path
        d="M6.05357 11.2C6.05357 11.2 6.57143 11 8.5 10C10.4286 9 10 7.5 10 7.5"
        stroke={color}
      />
    </svg>
  );
});
